import { useAuth } from 'components/Auth';
import { useIsTraumaCounsellor } from 'components/CriticalIncident/hooks/useIsTraumaCounsellor';
import { useFeatureManager } from 'hooks/useFeatureManager/useFeatureManager';
import { useSessionFlag } from 'hooks/useSessionFlag';
import { useLocation } from 'react-router-dom';

export const useNavigationUtils = () => {
    const { providerData, effectiveProviderData, authenticated } = useAuth();
    const { isCriticalIncidentFeatureEnabled, isIncidentReportFeatureEnabled } = useFeatureManager();
    const { pathname } = useLocation();

    const pathRoot = '/' + pathname.split('/').filter(Boolean).join('/');

    const showStaffTab = Boolean(
        (providerData?.providerId !== 0 && providerData?.isAdmin && providerData?.associateWithVendor) ||
            (providerData?.providerId === 0 &&
                effectiveProviderData?.isAdmin &&
                effectiveProviderData?.associateWithVendor)
    );

    const showCalendarTab = Boolean(effectiveProviderData?.hasManagedCalendar);

    const showInvoicingTab = Boolean(effectiveProviderData?.hasInvoicing);

    const { isTraumaCounsellor, isEAPCounsellor, isMixedCounsellor, loading } = useIsTraumaCounsellor(effectiveProviderData?.providerId);
    const hasNoContractedServices = !isTraumaCounsellor && !isEAPCounsellor;
    const enableCriticalIncident = useSessionFlag<boolean | undefined>('enable-critical-incident');
    const showCriticalIncidentTabs = isCriticalIncidentFeatureEnabled() && (enableCriticalIncident || isTraumaCounsellor || isMixedCounsellor);
    const showCICasesTab = showCriticalIncidentTabs && isIncidentReportFeatureEnabled();
    const showEAPTabs = isEAPCounsellor || isMixedCounsellor || hasNoContractedServices;

    return {
        pathRoot,
        showStaffTab,
        showCalendarTab,
        showInvoicingTab,
        authenticated,
        showCriticalIncidentTabs,
        showCICasesTab,
        showEAPTabs,
        loading
    };
};
